var NavbarVerticalStyle1Module = /** @class */ (function () {
    function NavbarVerticalStyle1Module() {
    }
    return NavbarVerticalStyle1Module;
}());
export { NavbarVerticalStyle1Module };
